import { BoardSections } from '../../../common/boards/boardConstants';
import { ElementType } from '../../../common/elements/elementTypes';
import { getLocationPathname } from '../../app/routingSelector';
import { createAndEditElement } from '../../element/actions/elementActions';
import { navigateToUrl } from '../../reducers/navigationActions';
import { getNewTransactionId } from '../../utils/undoRedo/undoRedoTransactionManager';

export const navigateToMobileQuickNotes = () => (dispatch: Function, getState: Function) => {
    const state = getState();
    const pathname = getLocationPathname(state);

    if (pathname !== '/mobile/quick-notes') {
        dispatch(navigateToUrl('/mobile/quick-notes'));
        return;
    }

    // If already in quicknotes then scroll to the top
    document.getElementsByClassName('MobilePageBody').item(0)?.scrollTo(0, 0);
};

const getElementLocation = (boardId: string) => ({
    parentId: boardId,
    section: BoardSections.INBOX,
    position: { index: 0 },
});

export const createAndEditNewQuickNoteElement = (boardId: string, type: ElementType) => async (dispatch: Function) => {
    const transactionId = getNewTransactionId();

    dispatch(navigateToMobileQuickNotes());

    dispatch(
        createAndEditElement({
            elementType: type,
            location: getElementLocation(boardId),
            currentBoardId: boardId,
            transactionId,
            content: '',
            select: true,
            edit: true,
        }),
    );
};
